import React, { useContext, useEffect, useState } from "react";
import StackedBarChart from "./StackedBarChart";
import { AxiosError, AxiosResponse } from "axios";
import { catchError } from "../../../utils/Utils";
import Service from "../../../services";
import "./dashboardkpis.scss";
import {
  Col,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import { BankUserContext } from "../../../bankUserContext";
import TrackerInfo from "./TrackerInfo";
import { toast } from "react-toastify";
import RangeBarChart from "./RangeBarChart";
import FinSpinner from "../../../commonfields/FinSpinner";
import timeFrame from "../../../images/timeFrame.svg";
import productImge from "../../../images/productIcon.svg";
import orgImage from "../../../images/orgIcon.svg";
import moment from "moment";
interface options {
  id: string;
  text: string;
  value: string;
}
interface DateOption {
  fromDate: string | null;
  toDate: string | null;
  option: string;
}
interface trackerList {
  option_text: string;
  kpi_tracker_options_id: number;
  option: string;
  tracker_master_id: string;
  defaultProductId?: string;
  productslist?: string;
  defaultOption: boolean;
}
type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];
function DashboardPage() {
  const [data, setChartData] = useState([]);
  const [isOn, setIsOn] = useState(false);
  const [notIdentified, setNotIdentified] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [customPopup, setCustomPopup] = useState<boolean>(false);
  const [customDateModal, setCustomDateModal] = useState<boolean>(false);
  const [fromyear, setFromYear] = useState("");
  const [toyear, setToYear] = useState("");
  const [productsData, setProductsData] = useState<options[]>([]);
  const [trackersList, setTrackerList] = useState<trackerList[]>([]);
  const [trackersName, setTrackerName] = useState<trackerList[]>([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [trackers, setTrackers] = useState([]);
  const [trackerId, setTrackerId] = useState("");
  const [productId, setProductId] = useState<any>(null);
  const [dateOption, setDateOption] = useState("");
  const [fromDateRange, setFromDateRange] = useState("");
  const [toDateRange, setToDateRange] = useState("");
  const [selectedDateOption, setSelectedDateOption] = useState<DateOption[]>(
    []
  );
  const [yearToDate, setYearToDate] = useState("");
  const [handleDateChanges, setHandleDateChanges] = useState();
  const [disabledApplyBtn, setDisabledApplyBtn] = useState(true);
  const [disbaledToDate, setDisabledToDate] = useState(true);
  const [toDateInputDisabled, setToDateInputDisabled] = useState(true);
  const [tableData, setTableData] = useState([
    { id: 20, name: 40, age: 30, count: 3 },
    { id: 34, name: 78, age: 25, count: 3 },
    { id: 45, name: 77, age: 33, count: 3 },
    { id: 33, name: 33, age: 35, count: 3 },
  ]);
  const columnHeaders = [
    "Awaiting Review",
    "In Review",
    "Managment Review",
    "Review Completed",
  ];
  const rowHeaders = [
    "DDA Account",
    "Commercial Loan",
    "Credit Card",
    "Not Identified",
  ];
  const footerRowHeader = "Total";
  const footerColumnHeaders = [
    "Total 1",
    "Total 2",
    "Total 3",
    "Total 4",
    "Total 5",
  ];

  const context = useContext(BankUserContext);
  const service = new Service();

  const handleOn = async () => {
    const updatedIsOn = !isOn;
    await setIsOn(updatedIsOn);
    getBarData({ ...data, isOn: !isOn });
  };

  const today = new Date();
  const oneYearAgo = new Date(
    today.getFullYear() - 1,
    today.getMonth(),
    today.getDate()
  );

  const getBarData = (data?: any) => {
    setLoader(true);
    const bardata = {
      screen: "dashboardscreen",
      sections: "dashboardBarChart",
      orgId: context.bankuserDetails?.organization.orgId,
      trackerMasterId: data.tracker_master_id || trackerId || null,
      productId: data.id === undefined ? null : data.id,
      fromDate: data?.fromDate || "",
      toDate: data?.toDate || "",
      isJsonReturnObject: false,
      roleId: context?.bankRolesData?.roleId,
      dealValue: data.isOn,
      isNotIdentifiedProduct: data.isNotIdentifiedProduct,
    };
    service
      .getdashboardBarChart(bardata)
      .then((response: AxiosResponse<any>) => {
        if (response.status == 200) {
          setChartData(
            response.data?.map((p: any) => {
              // p.value = p.productid;
              // p.label = p.productname + " - " + p.account;
              // setProductInfo(response.data);
              return p;
            })
          );
  
          setLoader(false);
          setFromDateRange('');
          setToDateRange('');
          setDisabledApplyBtn(true);
          setDisabledToDate(true);
          setToDateInputDisabled(true);
        }
        
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
        setLoader(false);
      });
  };

  const transformData = (data: any) => {
    const labels = Array.from(new Set(data.map((item: any) => item.monthName)));
    const datasets = Array.from(
      new Set(data.map((item: any) => item.productName))
    ).map((product) => ({
      label: product,
      data: labels.map((month) => {
        const entry = data.find(
          (item: any) =>
            item.monthName === month && item.productName === product
        );
        return entry ? entry.leadsCreatedThisMonth : 0;
      }),
    }));

    return { labels, datasets };
  };

  const getKPIDashBoard = (data: any) => {
    setLoader(true);
    const tabledata = {
      trackerMasterId: data.tracker_master_id || trackerId || null,
      orgLevelProductId: data.id === undefined ? null : data.id,
      orgId: context.bankuserDetails?.organization.orgId,
      roleId: context?.bankRolesData?.roleId,
      isNotIdentifiedProduct: data.isNotIdentifiedProduct,
    };
    service
      .getKPIDashBoard(tabledata)
      .then((response: AxiosResponse<any>) => {
        if (response.data) {
          setTrackers(response.data);
          setLoader(false);
        }
      })
      .catch((error: AxiosError) => {
        setTrackers([]);
        catchError(error, true);
        setLoader(false);
      });
  };

  // const productsOptions = () => {
  //   setLoader(true);
  //   const dropDownData = {
  //     screen: "ProspectsTR",
  //     sections: "productDropDownList",
  //     isJsonReturnObject: true,
  //     orgId: context.bankuserDetails?.organization.orgId,
  //   };
  //   service
  //     .getDropDownData(dropDownData)
  //     .then((response: AxiosResponse<any>) => {
  //       if (response.data) {
  //         setProductsData(response.data[0].productname);
  //         setLoader(false);
  //       }
  //     })
  //     .catch((error: AxiosError) => {
  //       catchError(error, true);
  //       setLoader(false);
  //     });
  // };
  const selectTimeOptions = () => {
    setLoader(true);
    const selectTime = {
      screen: "dashboardscreen",
      sections: "dashboardKPIDateOptions",
      isJsonReturnObject: false,
    };

    service
      .getLeadsData(selectTime)
      .then((response: AxiosResponse<any>) => {
        if (response.data) {
          setSelectedDateOption(response?.data);
          setLoader(false);
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
        setLoader(false);
      });
  };
  const getTrackerList = () => {
    setLoader(true);
    const getTrackers = {
      screen: "dashboardscreen",
      sections: "getTrackersList",
      isJsonReturnObject: false,
      orgId: context.bankuserDetails?.organization.orgId,
      roleId: context?.bankRolesData?.roleId,
    };
    service
      .getDropDownData(getTrackers)
      .then((response: AxiosResponse<any>) => {
        if (response.data) {
          setTrackerList(response.data);
          setLoader(false);
        }
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
        setLoader(false);
      });
  };

  const getProductsDropDownHandler = (data: any) => {
    service.getProductsDropDown(data).then((response: AxiosResponse<any>) => {
      if (response.data) {
        response.data.forEach((product: any) => {
          if (product.text === "Not Identified") {
            product.id = "f88a3a9e-557c-47dd-9cb2-4e5e9c5f4b2a";
          }
          if (product.text === "All Products") {
            product.id = "43ce11df-152c-48b9-a3e8-b93e3f02fa2f";
            setProductId("43ce11df-152c-48b9-a3e8-b93e3f02fa2f");
          }
        });
      }
      setProductsData(response.data);
    });
  };

  const handleTrackerChange = (event: any) => {
    const data = event.target.value;
    setTrackerId(data);
    const found: any =
      trackersList.find((t: any) => t.tracker_master_id === data) || {};
    const defaultProductId = found?.defaultProductId || null;
    const payload = {
      screen: "dashboardscreen",
      sections: "getKpiTrackerProducts",
      kpiTrackerProductId: found?.kpi_tracker_options_id,
      isJsonReturnObject: false,
    };
    getProductsDropDownHandler(payload);
    // const productslist = JSON.parse(found?.productslist || '[]');
    // setProductsData(productslist);
    const _pId =
      productsData.find((p) => p.id === defaultProductId)?.id || null;
    setProductId(_pId);
    setIsOn(isOn);
    getKPIDashBoard({ tracker_master_id: data, id: _pId });
    getBarData({ tracker_master_id: data, id: _pId, isOn: isOn });
    setYearToDate("Year To Date");

    // if(found?.option_text === "Relationships" || found?.option_text === "Sales"){
    //   setProductId("43ce11df-152c-48b9-a3e8-b93e3f02fa2f");
    // }
  };

  const handleProductChange = (event: any) => {
    //  let not_Identified = false;
    let isNotIdentifiedProduct = false;
    let pid = event.target.value;
    const data = event.target.value;
    if (data === "f88a3a9e-557c-47dd-9cb2-4e5e9c5f4b2a") {
      isNotIdentifiedProduct = true;
      pid = null;
    } else if (data === "43ce11df-152c-48b9-a3e8-b93e3f02fa2f") {
      pid = null;
      isNotIdentifiedProduct = false;
    } else {
      isNotIdentifiedProduct = false;
      pid = data;
    }
    setProductId(pid);
    setNotIdentified(isNotIdentifiedProduct);
    getKPIDashBoard({
      id: pid,
      tracker_master_id: trackerId,
      isOn: isOn,
      isNotIdentifiedProduct: isNotIdentifiedProduct,
    });
    getBarData({
      id: pid,
      tracker_master_id: trackerId,
      isOn: isOn,
      isNotIdentifiedProduct: isNotIdentifiedProduct,
    });
    // setSelectedDateOption([]);
    // selectTimeOptions();
    setYearToDate("Year To Date");
  };

  const handleDateChange = (event: any) => {
    const data = event.target.value && JSON.parse(event.target.value);
    setYearToDate(event.target.value);
    setDateOption(data?.option);
    if (data?.option === "Custom") {
      setCustomDateModal(true);
      if (productId == "43ce11df-152c-48b9-a3e8-b93e3f02fa2f") {
        setProductId(null);
      }
    } else {
      setCustomDateModal(false);
      if (productId == "43ce11df-152c-48b9-a3e8-b93e3f02fa2f") {
        setProductId(null);
      }
      getBarData({
        ...data,
        id: productId,
        tracker_master_id: trackerId,
        isOn: isOn,
      });
    }
  };

  const handleCustomPopup = () => {
    setCustomDateModal(!customDateModal);
    setYearToDate("Year To Date");
    setFromDateRange("");
    setToDateRange("");
    getBarData({
      ...data,
      id: productId,
      tracker_master_id: trackerId,
      isOn: isOn,
    });
    setDisabledApplyBtn(true);
    setDisabledToDate(true);
    setToDateInputDisabled(true);
  };

  useEffect(() => {
    // productsOptions();
    selectTimeOptions();
    getTrackerList();

    // getKPIDashBoard({...trackerId, ...productId});
  }, []);

  useEffect(() => {
    if (trackersList.length) {
      const found: any = trackersList.find((tL: any) => tL.defaultOption) || {};
      setTrackerId(found?.tracker_master_id);
      const defaultProductId = found?.defaultProductId || null;
      //const productslist = JSON.parse(found?.productslist || '[]');
      //setProductId(productslist.find((p:any)=>p.id === defaultProductId)?.id || null);
      //setProductId(productsData?.[0]?.id);
      getKPIDashBoard({ ...found });
      getBarData({ ...found, isOn: isOn });
      //setProductsData(productslist);
      const payload = {
        screen: "dashboardscreen",
        sections: "getKpiTrackerProducts",
        kpiTrackerProductId: found?.kpi_tracker_options_id,
        isJsonReturnObject: false,
      };
      getProductsDropDownHandler(payload);
    }
  }, [trackersList]);

  function getLastDateOfMonth(selectedMonth: any) {
    // Split the selectedMonth into year and month
    const [year, month] = selectedMonth.split("-");
    // Create a Date object for the first day of the next month
    const nextMonthFirstDay = new Date(year, parseInt(month, 10), 1);
    // Subtract 1 day from the first day of the next month to get the last day of the selected month
    const lastDateOfMonth = new Date(nextMonthFirstDay.getTime() - 86400000); // 86400000 milliseconds = 1 day
    return lastDateOfMonth.getDate(); // Get the day of the month
  }

  const currentDate = new Date();
  const currentMonth = currentDate.toISOString().slice(0, 7);
  const getCurrentYearMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    return `${year}-${month}`;
  };

  const applyCustomFilter = (e: any) => {
    if (!fromDateRange && !toDateRange) {
      toast.error("Invalid Date Range");
      return; // Exit the function early if either is empty
    }

    e?.preventDefault();
    const fD = new Date(fromDateRange),
      tD = new Date(toDateRange);
    const diff = tD.getTime() - fD.getTime();
    if (diff < 0 || diff > 19 * 30 * 24 * 60 * 60 * 1000) {
      toast.error("Date Range Exceeds 18 Months");
    } else {
      setCustomDateModal(false);
      getBarData({
        fromDate: moment(fromDateRange).format("MM/DD/yyyy"),
        toDate: moment(toDateRange).format("MM/DD/yyyy"),
        id: productId,
        tracker_master_id: trackerId,
        isOn: isOn,
      });
    }
    // setFromDateRange('');
    // setToDateRange('');
    // setDisabledApplyBtn(true);
    // setDisabledToDate(true);
    // setToDateInputDisabled(true);
  };

  const handleChangeFromMonth = (event: any) => {
    setFromDateRange(event.target.value);
    setToDateInputDisabled(false);
    if (event.target.value) {
      setDisabledApplyBtn(true);
    }
    // if (event.target.value > toDateRange) {
    //   setToDateRange('');
    // }
  };
  const handleChangeToMonth = (event: any) => {
    const selectedMonth = event.target.value;
    const lastDateOfMonth = getLastDateOfMonth(selectedMonth);
    setToDateRange(selectedMonth + "-" + lastDateOfMonth);
    setDisabledToDate(false);
    if (event.target.value) {
      setDisabledToDate(false);
    }
  };

  return (
    <>
      {loader ? <FinSpinner /> : null}
      <div className="dashboard">
        <div className="dropdown-data">
          <div className="one">
            <Input
              className="select-tracker"
              name="select"
              type="select"
              value={trackerId}
              onChange={(event) => handleTrackerChange(event)}>
              {trackersList?.map((p, index) => (
                <option key={index} value={p?.tracker_master_id}>
                  {p.option_text}
                </option>
              ))}
            </Input>
          </div>
          <div className="select-dropdown">
            <div className="productImg">
              <img className="product" src={orgImage} alt="orgImage" />
              <Input
                className="select orgLevel"
                name="select"
                type="select"
                disabled>
                {productsData.map((p: any) => (
                  <option value={p.text}>{"Select Org Level"}</option>
                ))}
              </Input>
            </div>

            <div className="productImg">
              <img className="product" src={productImge} alt="productImge" />
              <Input
                className="select"
                name="select"
                type="select"
                value={productId}
                onChange={(event) => handleProductChange(event)}>
                {
                  // productId === '' && notIdentified===false &&<>
                  // <option  value=''>All Products </option>
                  // </>
                }
                {productsData.map((p: any) => (
                  <option key={p.id} value={p.id === "" ? null : p.id}>
                    {" "}
                    {p.text}
                  </option>
                ))}
              </Input>
            </div>
          </div>
        </div>
        <div className="box-container">
          <div className="container">
            <div>
              <TrackerInfo
                trackers={trackers}
                trackersList={trackersList}
                trackerId={trackerId}></TrackerInfo>
            </div>
          </div>
        </div>

        <div className="box-container">
          <div className="container">
            <div className="stackedBarChart">
              <div className="total-chart">
                {(
                  trackersList.find(
                    (t: any) => t.tracker_master_id === trackerId
                  ) || {}
                )?.option_text !== "Relationships" ? (
                  <div className="tittle-row">
                    <div className="title">
                      <div className="tittle-name">
                        New{" "}
                        {
                          (
                            trackersList.find(
                              (t: any) => t.tracker_master_id === trackerId
                            ) || {}
                          )?.option_text
                        }{" "}
                        Pipeline Over Time
                      </div>
                      <div className="selectSubOrd">
                        <Input
                          className="select sub-org"
                          name="select"
                          type="select"
                          disabled>
                          {productsData.map((p: any) => (
                            <option value={p.value}>{"Select Sub-Org"}</option>
                          ))}
                        </Input>
                      </div>
                    </div>

                    <div>
                      <div className="timeFrame">
                        <img
                          className="calenderImage"
                          src={timeFrame}
                          alt="timeFrame"
                        />
                        <Input
                          className="select"
                          name="select"
                          type="select"
                          value={yearToDate}
                          onChange={(event) => handleDateChange(event)}>
                          {selectedDateOption === null && (
                            <option
                              value={JSON.stringify({
                                option: "Year To Date",
                              })}>
                              Year To Date
                            </option>
                          )}
                          {selectedDateOption?.map(
                            (option: DateOption, index: number) => (
                              <option
                                key={index}
                                value={JSON.stringify(option)}>
                                {option?.option}
                              </option>
                            )
                          )}
                        </Input>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="tittle-relationship">
                    <div className="title">
                      <div className="tittle-name">Sales</div>
                      <div className="switch-container">
                        <button
                          className={`switch-button ${
                            isOn ? "active" : "deactive"
                          }`}
                          //onClick={handleOn}
                          onClick={handleOn}
                          disabled={isOn}>
                          Deal Value
                        </button>
                        <button
                          disabled={!isOn}
                          className={`switch-button ${
                            isOn ? "deactive" : "active"
                          }`}
                          onClick={handleOn}>
                          Number of Sales
                        </button>
                        <div></div>
                      </div>
                    </div>
                    <div className="timeFrame">
                      <img
                        className="calenderImage"
                        src={timeFrame}
                        alt="timeFrame"
                      />
                      <Input
                        className="select"
                        name="select"
                        type="select"
                        value={yearToDate}
                        onChange={(event) => handleDateChange(event)}>
                        {selectedDateOption === null && (
                          <option
                            value={JSON.stringify({ option: "Year To Date" })}>
                            Year To Date
                          </option>
                        )}
                        {selectedDateOption?.map(
                          (option: DateOption, index: number) => (
                            <option key={index} value={JSON.stringify(option)}>
                              {option?.option}
                            </option>
                          )
                        )}
                      </Input>
                    </div>
                  </div>
                )}

                <div
                  className={
                    (
                      trackersList.find(
                        (t: any) => t.tracker_master_id === trackerId
                      ) || {}
                    )?.option_text !== "Relationships"
                      ? "chart"
                      : "relationshipChart"
                  }>
                  {(
                    trackersList.find(
                      (t: any) => t.tracker_master_id === trackerId
                    ) || {}
                  )?.option_text !== "Relationships" ? (
                    <StackedBarChart data={transformData(data)} />
                  ) : (
                    <>
                      <RangeBarChart data={data} />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <>
          <Modal isOpen={customDateModal} className="decision-modal" centered>
            <ModalHeader toggle={handleCustomPopup}>
              <div className="">Select Range</div>
            </ModalHeader>
            <ModalBody>
              <Row className="select-date">
                <Col>
                  <Label className="from-date"> From </Label>
                </Col>
                <Col>
                  <Input
                    id="month"
                    name="Month"
                    placeholder="Month"
                    type="month"
                    max={currentMonth}
                    // onChange={(e:any)=>{
                    //   setFromDateRange(e.target.value+'-01');
                    // }}
                    onChange={handleChangeFromMonth}
                  />
                </Col>
              </Row>

              <Row className="select-date">
                <Col>
                  <Label className="to-date"> To </Label>
                </Col>
                <Col>
                  <Input
                    id="month"
                    name="Month"
                    type="month"
                    placeholder="Month"
                    max={getCurrentYearMonth()}
                    min={fromDateRange}
                    onChange={handleChangeToMonth}
                    disabled={toDateInputDisabled}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Row>
                <Col>
                  {" "}
                  <Input
                    className={
                      disabledApplyBtn && disbaledToDate
                        ? "disabledApplyBtn"
                        : "apply"
                    }
                    type="button"
                    disabled={disabledApplyBtn && disbaledToDate}
                    onClick={applyCustomFilter}
                    value={"Apply"}
                  />
                </Col>
                <Col>
                  {" "}
                  <Input
                    className="cancel"
                    type="button"
                    onClick={handleCustomPopup}
                    value={"Cancel"}
                  />
                </Col>
              </Row>
            </ModalFooter>
          </Modal>
        </>

        {/* <RangeBarChart/> */}
      </div>
    </>
  );
}

export default DashboardPage;
